import { useTranslate } from "@similarweb/i18n-provider";
import { Table } from "@similarweb/pro-logic-components";
import { SearchInput } from "@similarweb/ui-components";

import type { WebsitesDigitalAssetRecord } from "app/pages/sales-intelligence/modules/company-analysis/types/digital-assets";
import { digitalAssetTypeMap } from "app/pages/sales-intelligence/modules/company-analysis/types/digital-assets";

import { SearchBoxLoader } from "../../../components/shared/Loader/SearchBoxLoader";
import { getNoData } from "../../../constants";
import { useFilteredDigitalAssetsData } from "../../../hooks/useFilteredDigitalAssetsData";
import { getWebsitesDigitalAssetsColumns } from "../columns";

import { StyledSearchInputContainer, StyledTableWrapper } from "./styles";

const websitesSearchAccessor = (item: WebsitesDigitalAssetRecord) => item.domain;

const WebsitesCardContent = () => {
    const { translate } = useTranslate();

    const { displayedData, isLoading, totalCount, paginationProps, onSearchChange, showSearch } =
        useFilteredDigitalAssetsData({
            assetType: digitalAssetTypeMap.websites,
            withTotal: false,
            getSearchValue: websitesSearchAccessor,
        });

    return (
        <section data-automation="digital-assets-websites-table">
            {isLoading ? (
                <SearchBoxLoader />
            ) : showSearch ? (
                <StyledSearchInputContainer>
                    <SearchInput
                        data-automation="digital-assets-websites-search"
                        debounce={300}
                        onChange={onSearchChange}
                        placeholder={`${translate("common.placeholder.search")}...`}
                    />
                </StyledSearchInputContainer>
            ) : null}

            <StyledTableWrapper withBorder={showSearch}>
                <Table
                    isLoading={isLoading}
                    data={displayedData}
                    columnConfig={getWebsitesDigitalAssetsColumns(totalCount)}
                    pagination={paginationProps}
                    noData={getNoData()}
                    withArrowButtons
                />
            </StyledTableWrapper>
        </section>
    );
};
export default WebsitesCardContent;
